import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'styles/styles.css';

import { App } from './components/App'
ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
);